import { george, pr } from "aaa";
import { FeatureRoutes } from "components/app/AppRoutes";
import { IconCardNewXl, IconCardReplacementXl } from "components/util/primitives";
import { ui } from "components/util/uiHelpers";
import { observer } from "mobx-react";
import { themeColors } from "muiTheme";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import { ReissueCardRoutes } from "components/reissueCard/ReissueCardRoutes";

const CardSection = ({ children }: { children: React.ReactNode }) => (
    <div style={{ display: "flex", alignItems: "center", flexDirection: "column", flexGrow: 1, flexBasis: 0, padding: 32 }}>
        {children}
    </div>
);

export const ReissueCardUpgrade = observer(() => {
    const BackgroundComponent = externalInterfaceStore.isGeorgeApp ? george.Background : george.BackgroundWithNavBar;
    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;
    const separatorColor = ui.isDarkMode ? themeColors.d_grey_100 : themeColors.grey_200;

    const handleClickUpgradeCard = () => {
        pushRoute(FeatureRoutes.CREDIT_CARD_UPGRADE);
    };

    const handleClickReissueCard = () => {
        pushRoute(ReissueCardRoutes.REISSUE);
    };

    return (
        <BackgroundComponent>
            <george.Card style={{ padding: 0 }}>
                <pr.HFlex
                    style={{
                        justifyContent: "space-between",
                        flexDirection: isMobile ? "column" : "row",
                    }}
                >
                    <CardSection>
                        <IconCardNewXl style={{ width: 50, height: 50, color: themeColors.grey_300 }} />
                        <pr.P_18_TITLE style={{ fontWeight: "bold", marginTop: 24 }}>
                            {ui.__("reissueCardUpgrade.upgrade.title")}
                        </pr.P_18_TITLE>
                        <GdsFakeActionButton
                            color="primary"
                            style={{ minWidth: 0, marginTop: 24 }}
                            onClick={handleClickUpgradeCard}
                        >
                            {ui.__("reissueCardUpgrade.upgrade.button.text")}
                        </GdsFakeActionButton>
                        <pr.P_14_CONTENT style={{ textAlign: "center", marginTop: 16 }}>
                            {ui.__("reissueCardUpgrade.upgrade.message")}
                        </pr.P_14_CONTENT>
                    </CardSection>
                    <div
                        style={{
                            borderLeft: isMobile ? undefined : `1px solid ${separatorColor}`,
                            borderBottom: isMobile ? `1px solid ${separatorColor}` : undefined,
                        }}
                    />
                    <CardSection>
                        <IconCardReplacementXl style={{ width: 50, height: 50, color: themeColors.grey_300 }} />
                        <pr.P_18_TITLE style={{ fontWeight: "bold", marginTop: 24 }}>
                            {ui.__("reissueCardUpgrade.reissueCard.title")}
                        </pr.P_18_TITLE>
                        <GdsFakeActionButton
                            style={{ minWidth: 0, marginTop: 24 }}
                            onClick={handleClickReissueCard}
                        >
                            {ui.__("reissueCardUpgrade.reissueCard.button.text")}
                        </GdsFakeActionButton>
                        <pr.P_14_CONTENT style={{ textAlign: "center", marginTop: 16 }}>
                            {ui.__("reissueCardUpgrade.reissueCard.message")}
                        </pr.P_14_CONTENT>
                    </CardSection>
                </pr.HFlex>
            </george.Card>
        </BackgroundComponent>
    );
});



// WEBPACK FOOTER //
// ./src/components/reissueCardUpgrade/ReissueCardUpgrade.tsx